import { Routes } from '@angular/router';
import { AuthGuard } from '@core/auth/guards/auth.guard';

export const STARTERS_LIST_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./starters-list.component').then(m => m.StartersListComponent),
    canActivate: [AuthGuard],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./starters-list-detail/starters-list-detail.component').then(m => m.StartersListDetailComponent),
    canActivate: [AuthGuard],
  }
];
